import { getBooleanFromEnv } from "../../common/utilities/env";
import { REFRESH_TOKEN_COOKIE } from "../constants";

const ENABLE_AUTH_OIDC = getBooleanFromEnv("ENABLE_AUTH_OIDC");

// OIDC = OpenID Connect
export const isAuthProviderOidc = () => {
  return ENABLE_AUTH_OIDC;
};

export const hasRefreshTokenCookie = (): boolean => {
  if (typeof document === "undefined") {
    return false;
  }
  return document.cookie
    .split(";")
    .some((c) => c.trim().startsWith(`${REFRESH_TOKEN_COOKIE}=`));
};

// The decoded payload is arbitrary IdP-defined JSON: callers read standard
// claims (`exp`) but also spread the whole payload into an oidc-client-ts
// `User`. Narrowing the return type here would break those call sites, so the
// shape stays `any` until the OIDC user mapping is modelled explicitly.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const parseJwt = (token: string): any => {
  return JSON.parse(atob(token.split(".")[1]));
};

export const getTokenExpiry = (token: string): number | null => {
  try {
    const payload = parseJwt(token);
    return payload?.exp ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
};

export const isTokenExpired = (token: string): boolean => {
  try {
    const expiry = getTokenExpiry(token);
    if (!expiry) {
      return true;
    }
    return Date.now() >= expiry;
  } catch {
    return true;
  }
};
